package org.chiangmeng.qfast.core.data.di

import org.chiangmeng.qfast.core.data.remote.FirebaseQueueRepositoryImpl
import org.chiangmeng.qfast.core.domain.ports.QueueRepository
import org.koin.dsl.module

val dataModule = module {
    single<QueueRepository> {
        FirebaseQueueRepositoryImpl(
            firebaseDatabase = get(),
            historyQueries = get()
        )
    }
}